module.exports = __webpack_public_path__ + "static/media/house-2.5d40ac55.jpg";